import { createFileRoute } from "@tanstack/react-router";
import { canonicalLink, pathFromMatch, routeMeta } from "@/lib/seo";
import { cityHeadScripts } from "@/lib/cityJsonLd";
import { CityHomePage } from "@/components/CityHomePage";
import hero from "@/assets/original/hero-shade.jpg";

export const Route = createFileRoute("/mcallen")({
  head: (ctx) => ({
    links: [canonicalLink(pathFromMatch(ctx))],
    meta: routeMeta(ctx, {
      title: "Custom Awnings, Covers & Shade in McAllen, TX | Texas Made Shade",
      description: "Custom welded awnings, patio & pergola covers, sail shades and commercial canopies for McAllen & the Rio Grande Valley. Free quotes — +1 (830) 390-9588.",
      keywords: "pergola covers McAllen, pergola covers Texas, custom pergola covers McAllen, aluminum pergola covers McAllen",
      image: hero,
      socialTitle: "Custom Awnings & Shade — McAllen, TX",
      socialDescription: "Welded aluminum + Sunbrella canvas. Custom shade, covers and fabrication serving McAllen and Hidalgo County.",
    }),
    scripts: cityHeadScripts("McAllen", "Hidalgo County"),
  }),
  component: () => <CityHomePage city="McAllen" region="Hidalgo County" />,
});
